import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Table, Button, Dropdown, DropdownButton, FormControl } from 'react-bootstrap';
import { Link, useSearchParams } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Image from 'react-bootstrap/Image';
import Accordion from 'react-bootstrap/Accordion';
import PageShell from './ui/PageShell';
import ActionIcon from './ui/ActionIcon';
import AppModal from './ui/AppModal';
import API_BASE_URL, { api } from '../config/api';
import { useLayout, CANDIDATE_ACTIVITY_REFRESH_KEYS } from '../layout/AppLayout';
import { getDecryptedData } from '../utils/authStorage';
import {
  canClaimRequirement,
  canUnclaimRequirement,
  canUploadToRequirement,
  getUploadDisabledMessage,
} from '../utils/requirementWorkflow';
import { unclaimRequirement as unclaimRequirementApi } from '../services/requirementService';
import RequirementRejectedModal from './requirements/RequirementRejectedModal';
import RequirementJdActions from './requirements/RequirementJdActions';
import { getRejectedCandidates } from '../services/candidateService';
import {
  ALL_STATUS_OPTIONS,
  canEditFullSourceProfileDetails,
  getRecentCandidateStatus,
} from '../utils/candidateStatus';
import SourceProfileDocumentFields from './ui/SourceProfileDocumentFields';
import { buildApiAssetUrl } from '../utils/apiAssetUrl';
import StatusBadge from './ui/StatusBadge';
import StatusHistorySection from './ui/StatusHistorySection';
import { mergeCandidateStatusRemarkUpdate } from '../utils/statusRemarks';
import { normalizeCandidateList, normalizeCandidateRecord, normalizeRecruiterCandidateGroups } from '../utils/candidateListState';
import { matchesUploadedDateRange, getDefaultRequirementListMonthRange } from '../utils/requirementDateFilter';
import { getPrioritySortIndex, normalizeRequirementPriority, sortByPriorityThenUploadedDate } from '../utils/requirementPriority';
import PriorityBadge from './ui/PriorityBadge';
import RequirementDateRangeFilter from './ui/RequirementDateRangeFilter';
import {
  formatDisplayDate,
  formatInterviewDate,
  formatLwdDisplay,
  normalizeLwdForInput,
  toDateInputValue,
} from '../utils/dateFormat';
import {
  isRequirementWorkBlocked,
  matchesRequirementTypeFilter,
  normalizeRequirementType,
} from '../utils/requirementType';
import { isActiveOpenRequirement } from '../utils/dashboardStats';
import {
  getRequirementSourceBadgeClass,
  getRequirementSourceFromRow,
} from '../utils/requirementSource';
import { showSuccess, showError, showWarning, showInfo } from '../utils/toast';
import { getApiErrorMessage } from '../utils/apiError';
import { highlightProfileRow } from '../utils/profileDeepLink';






const WORKBENCH_TABS = [
  { id: 'new', label: 'New Requirements' },
  { id: 'priority', label: 'Priority Requirement List' },
  { id: 'claimed', label: 'Claimed Requirements' },
];
const DEFAULT_WORKBENCH_TAB = 'claimed';
const REQUIREMENT_TYPES = ['high', 'medium', 'low', 'hold', 'cancel'];

const DEFAULT_WORKBENCH_DATE_RANGE = getDefaultRequirementListMonthRange();

function matchesRequirementSearch(requirement, query) {
  const q = String(query || '').trim().toLowerCase();
  if (!q) return true;
  return (
    (requirement?.client || '').toLowerCase().includes(q)
    || String(requirement?.regId || '').toLowerCase().includes(q)
    || String(requirement?._id || '').toLowerCase().includes(q)
    || (requirement?.role || '').toLowerCase().includes(q)
  );
}

function Home() {
  const { openFormModal, tableRefresh, triggerTableRefresh } = useLayout();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = WORKBENCH_TABS.some((tab) => tab.id === searchParams.get('tab'))
    ? searchParams.get('tab')
    : DEFAULT_WORKBENCH_TAB;
  const setActiveTab = (tabId) => {
    const nextParams = new URLSearchParams(searchParams);
    nextParams.set('tab', tabId);
    setSearchParams(nextParams, { replace: false });
  };

  const focusedRequirementId = searchParams.get('requirementId') || '';
  const focusedProfileId = searchParams.get('profileId') || '';
  const profileDeepLinkRef = useRef('');
  const profileModalDeepLinkRef = useRef('');

  useEffect(() => {
    if (!searchParams.get('tab')) {
      setSearchParams({ tab: DEFAULT_WORKBENCH_TAB }, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  const [requirements, setRequirements] = useState([]);
  const [claimedData, setClaimedData] = useState([]);
  const [candidateCounts, setCandidateCounts] = useState({});
  const [rejectedCounts, setRejectedCounts] = useState({});
  const [showRejectedModal, setShowRejectedModal] = useState(false);
  const [rejectedModalMeta, setRejectedModalMeta] = useState({ regId: '', requirementId: '' });
  const [rejectedRows, setRejectedRows] = useState([]);
  const [rejectedLoading, setRejectedLoading] = useState(false);
  const [sortedRequirements, setSortedRequirements] = useState([]);
  const [sortedClaimRequirements, setSortedClaimRequirements] = useState([]);
  const [sortOrder, setSortOrder] = useState('desc');
  const [sortUploadedOrder, setSortUploadedOrder] = useState('desc');
  const [sortClaimedDateOrder, setSortClaimedDateOrder] = useState('desc'); 
  const [requirementData, SetRequirementData] = useState({}); // Changed to object
  const [lgShow, setLgShow] = useState(false);
  const [show, setShow] = useState(false);
  const [viewCandidate,setViewCandidate] = useState(false);
  const [updateshow, setUpdateshow] = useState(false);
  const [candidateData,setCandidateData] = useState([]);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [selectedTypes, setSelectedTypes] = useState(['high', 'medium', 'low', 'hold', 'cancel']);
  const [savedStatusSearchTerm, setSavedStatusSearchTerm] = useState('');
  const [expandedId, setExpandedId] = useState(null);
  const [activeReqId, setActiveReqId] = useState(null);
  const [selectedCandidateStatus] = useState('');
  const [candidateName] = useState('');
  const [nameSearchTerm, setNameSearchTerm] = useState('');
  const [statusSearchTerm, setStatusSearchTerm] = useState('');
  const [uploadedFromDate, setUploadedFromDate] = useState(DEFAULT_WORKBENCH_DATE_RANGE.from);
  const [uploadedToDate, setUploadedToDate] = useState(DEFAULT_WORKBENCH_DATE_RANGE.to);
  const [searchReq, setSearchReq] = useState('');
  const statusOptions = ALL_STATUS_OPTIONS;

  const filteredCandidates = (Array.isArray(candidateData) ? candidateData : []).filter((item) => {
    const fullName = `${item.firstName} ${item.lastName}`.toLowerCase();
    const recentStatus = getRecentCandidateStatus(item).toLowerCase();

    const matchesSavedStatus = savedStatusSearchTerm
      ? (savedStatusSearchTerm === 'saved' && item.savedStatus === 'Saved')
        || (savedStatusSearchTerm === 'uploaded' && item.savedStatus === 'Uploaded')
      : true;

    return (
      fullName.includes(nameSearchTerm.toLowerCase())
      && (statusSearchTerm ? recentStatus === statusSearchTerm.toLowerCase() : true)
      && matchesSavedStatus
    );
  });

    const [updateCandidateDetails, setUpdateCandidateDetails] = useState({
    candidateImage: '',
    firstName: '',
    lastName: '',
    email: '',
    mobileNumber: '',
    dob: '',
    ctc: '',
    ectc: '',
    totalYoe: '',
    relevantYoe: '',
    lwd: '',
    currentLocation: '',
    prefLocation: '',
    resignationServed: '',
    currentOrg: '',
    candidateSkills: '',
    role: '',
    internalScreening: '',
    sharedWithClient: '',
    feedback: '',
    details: '',
    interviewDate: '',
    educationalQualification: '',
    offerInHand: '',
    remark: '',
    updatedResume: '',
    ornnovaProfile: '',
    assessments: [],
  });

  const userId = getDecryptedData("Id");

  function handleShow() {
    // setFullscreen();
    setShow(true);
  }
  function handleUpdateShow() {
    
    setUpdateshow(true);
  }
  function handleUpdateClose () {setUpdateshow(false);}
  const onHide = () => {
    setShow(false);
  };

  useEffect(() => {
    fetchRequirements(userId);
  }, [userId, tableRefresh.candidates, tableRefresh.requirements]);

//   const fetchRequirements = async (userId) => {
//     try {
//         const response = await api.get(`/getHomeReqData/${userId}`);
//         const data = response.data;

//         const newData = data.filter(req => req.update === 'New' && !req.claimedBy.some(claim => claim.userId === userId));
//         const claimedData = data.filter(req => req.update === 'Old' || req.claimedBy.some(claim => claim.userId === userId));

//         setRequirements(newData);
//         setClaimedData(claimedData);

//         // Initialize counts objects for saved and uploaded counts
//         const savedCounts = {};
//         const uploadedCounts = {};

//         // Fetch candidate counts for each claimed requirement
//         for (let req of claimedData) {
//             try {
//                 const res = await axios.get(`${API_BASE_URL}/viewactions/${req._id}/${userId}`);
//                 setCandidateCounts(res.data.candidateCount)
                
//                 console.log(res)
//                 // Assuming the response contains both savedCount and uploadedCount
//                 savedCounts[req._id] = res.data.savedCount || 0;
//                 uploadedCounts[req._id] = res.data.uploadedCount || 0;
                
//             } catch (err) {
//                 console.error(`Error fetching candidates for ${req._id}:`, err);
//                 savedCounts[req._id] = 0;
//                 uploadedCounts[req._id] = 0;
//             }
//         }

//         setUploadedCount(uploadedCounts);
//         setSavedCount(savedCounts);
//     } catch (err) {
//         console.error('Error fetching requirements:', err);
//     }
// };

const fetchRequirements = async (userId) => {
  try {
    const response = await api.get(`/getHomeReqData/${userId}`);
    const data = Array.isArray(response.data) ? response.data : [];
    const toClaim = data.filter((req) => canClaimRequirement(req));
    const claimed = data.filter((req) => !canClaimRequirement(req));
    setRequirements(toClaim);
    setClaimedData(claimed);

    if (claimed.length === 0) {
      setCandidateCounts({});
      setRejectedCounts({});
      return;
    }

    const reqIds = claimed.map((req) => req._id).join(',');
    const countsResponse = await api.get(`/candidateCounts/${userId}`, {
      params: { reqIds },
    });
    setCandidateCounts(countsResponse.data.counts || {});
    setRejectedCounts(countsResponse.data.rejectedCounts || {});
  } catch (err) {
    console.error('Error fetching requirements:', err);
    setRequirements([]);
    setClaimedData([]);
    setCandidateCounts({});
    setRejectedCounts({});
  }
};

const refreshActiveCandidates = async (reqId) => {
  if (!reqId || !userId) return;
  try {
    const response = await api.get(`/viewactions/${reqId}/${userId}`);
    setCandidateData(normalizeCandidateList(response.data.candidates || []));
  } catch (error) {
    setCandidateData([]);
  }
};

const refreshExpandedUploads = useCallback(async (reqId) => {
  if (!reqId || !userId) return;
  try {
    const response = await api.get(`/userUploads/${reqId}/${userId}`);
    setCandidateData(normalizeRecruiterCandidateGroups(response.data?.recruiters || []));
  } catch (error) {
    if (error.response?.status === 404) {
      setCandidateData([]);
      return;
    }
    console.error('Error refreshing uploads:', error);
  }
}, [userId]);

  useEffect(() => {
    if (expandedId) {
      refreshExpandedUploads(expandedId);
    }
  }, [expandedId, tableRefresh.candidates, refreshExpandedUploads]);

  useEffect(() => {
    if (!focusedRequirementId) return undefined;
    const allRequirements = [...(claimedData || []), ...(requirements || [])];
    if (!allRequirements.some((item) => String(item._id) === focusedRequirementId)) return undefined;

    const linkKey = `${focusedRequirementId}:${focusedProfileId}`;
    if (profileDeepLinkRef.current === linkKey) return undefined;

    let cancelled = false;
    const openFromDeepLink = async () => {
      const inClaimed = (claimedData || []).some((item) => String(item._id) === focusedRequirementId);
      const nextTab = inClaimed ? 'claimed' : 'new';
      if (searchParams.get('tab') !== nextTab) {
        const nextParams = new URLSearchParams(searchParams);
        nextParams.set('tab', nextTab);
        setSearchParams(nextParams, { replace: true });
      }

      try {
        const response = await api.get(`/userUploads/${focusedRequirementId}/${userId}`);
        if (cancelled) return;
        setCandidateData(normalizeRecruiterCandidateGroups(response.data?.recruiters || []));
        setExpandedId(focusedRequirementId);
        profileDeepLinkRef.current = linkKey;
      } catch (error) {
        if (error.response?.status === 404 && !cancelled) {
          setCandidateData([]);
          setExpandedId(focusedRequirementId);
          profileDeepLinkRef.current = linkKey;
        }
      }
    };

    openFromDeepLink();
    return () => {
      cancelled = true;
    };
  }, [
    focusedRequirementId,
    focusedProfileId,
    claimedData,
    requirements,
    searchParams,
    setSearchParams,
    userId,
  ]);

  useEffect(() => {
    if (!focusedProfileId || expandedId !== focusedRequirementId) return undefined;
    return highlightProfileRow(focusedProfileId, { delayMs: 450 });
  }, [focusedProfileId, focusedRequirementId, expandedId, candidateData]);

  const sortRequirements = useCallback(() => {
    const sorted = [...(requirements || [])].sort((a, b) => {
      const priorityDiff = getPrioritySortIndex(a.priority) - getPrioritySortIndex(b.priority);
      if (priorityDiff !== 0) return priorityDiff;
      const dateA = new Date(a.uploadedDate || 0);
      const dateB = new Date(b.uploadedDate || 0);
      return sortUploadedOrder === 'asc' ? dateA - dateB : dateB - dateA;
    });
    setSortedRequirements(sorted);
  }, [requirements, sortUploadedOrder]);

  const sortClaimedRequirements = useCallback(() => {
    setSortedClaimRequirements(sortByPriorityThenUploadedDate(claimedData || []));
  }, [claimedData]);

  useEffect(() => {
    sortRequirements();
  }, [sortRequirements, sortOrder]);

  useEffect(() => {
    sortClaimedRequirements();
  }, [sortClaimedRequirements]);

  const handleSort = () => setSortOrder(prev => prev === 'asc' ? 'desc' : 'asc');
  const handleUploadedSort = () => setSortUploadedOrder(prev => prev === 'asc' ? 'desc' : 'asc');
  const handleSortClaimedDate = () => {
    setSortClaimedDateOrder(sortClaimedDateOrder === 'asc' ? 'desc' : 'asc');
  };

    const sortedClaimedDateRequirements = [...(sortedClaimRequirements || [])].sort((a, b) => {
      const priorityDiff = getPrioritySortIndex(a.priority) - getPrioritySortIndex(b.priority);
      if (priorityDiff !== 0) return priorityDiff;

      const dateA = new Date(
        a.currentClaimedBy?.claimedDate
        || a.workflow?.currentClaimedBy?.claimedDate
        || (a.claimedBy || []).find((claim) => claim.userId === userId)?.claimedDate
      );
      const dateB = new Date(
        b.currentClaimedBy?.claimedDate
        || b.workflow?.currentClaimedBy?.claimedDate
        || (b.claimedBy || []).find((claim) => claim.userId === userId)?.claimedDate
      );

      return sortClaimedDateOrder === 'asc' ? dateA - dateB : dateB - dateA;
    });

  const priorityRequirements = useMemo(() => {
    const combined = [...(requirements || []), ...(claimedData || [])];
    const unique = Array.from(new Map(combined.map((req) => [req._id, req])).values());
    return sortByPriorityThenUploadedDate(
      unique.filter((req) => normalizeRequirementPriority(req.priority) !== null),
    );
  }, [requirements, claimedData]);

  const filteredPriorityRequirements = useMemo(() => (
    priorityRequirements
      .filter((req) => matchesUploadedDateRange(req.uploadedDate, uploadedFromDate, uploadedToDate))
      .filter((req) => matchesRequirementSearch(req, searchReq))
      .filter((req) => {
        if (canClaimRequirement(req)) return true;
        if (selectedTypes.length === 0) return true;
        if (selectedTypes.length === REQUIREMENT_TYPES.length) return true;
        return matchesRequirementTypeFilter(req.requirementtype, selectedTypes);
      })
  ), [priorityRequirements, uploadedFromDate, uploadedToDate, searchReq, selectedTypes]);

  const updateClaim = async (id) => {
    const user = {
      userId,
      claimedDate: new Date(),
    };

    try {
      const { data: result } = await api.put(`/claim/${id}`, user);
      if (result.status === "Success") {
        showSuccess(result.msg || 'Requirement claimed successfully ✓');
        triggerTableRefresh(CANDIDATE_ACTIVITY_REFRESH_KEYS);
      } else {
        showError(result.msg || 'Failed to claim requirement. Please try again.');
      }
    } catch (error) {
      console.error('Error updating claim:', error);
      showError(getApiErrorMessage(error, 'Error updating claim. Please try again later.'));
    }
  };

  const handleUnclaim = async (id) => {
    try {
      const result = await unclaimRequirementApi(id, { userId });
      if (result.status === 'Success') {
        showSuccess(result.msg || 'Requirement unclaimed successfully ✓');
        triggerTableRefresh(CANDIDATE_ACTIVITY_REFRESH_KEYS);
      } else {
        showError(result.msg || 'Unable to unclaim this requirement.');
      }
    } catch (error) {
      showError(getApiErrorMessage(error, 'Unable to unclaim this requirement.'));
    }
  };

  const viewCandidates = async(id)=>{
    try {
      setActiveReqId(id);
      const response = await api.get(`/viewactions/${id}/${userId}`)
      setCandidateData(normalizeCandidateList(response.data.candidates || []));
      console.log(response.data)
      handleShow()
    } catch (error) {
      showError(getApiErrorMessage(error, 'No candidates found for this requirement.'));
    }
  }

  const openRejectedModal = async (requirementId, regId) => {
    setRejectedModalMeta({ regId: regId || '', requirementId });
    setShowRejectedModal(true);
    setRejectedLoading(true);
    try {
      const response = await getRejectedCandidates(requirementId, userId);
      setRejectedRows(response.rows || []);
    } catch (error) {
      console.error('Error loading rejected candidates:', error);
      setRejectedRows([]);
    } finally {
      setRejectedLoading(false);
    }
  };

  const closeRejectedModal = () => {
    setShowRejectedModal(false);
    setRejectedModalMeta({ regId: '', requirementId: '' });
    setRejectedRows([]);
  };

//   const viewCandidates = async (id) => {
//     try {
//         const response = await api.get(`/viewactions/${id}/${userId}`);
        
//         // Destructure the response data to get counts and candidates details
//         const { savedCount, uploadedCount, savedCandidates, uploadedCandidates,candidates,candidateCount} = response.data;
        
//       //   if (candidateType === 'Uploaded') {
//       //     setCandidateData(uploadedCandidates);
//       // } else if (candidateType === 'Saved') {
//       //     setCandidateData(savedCandidates);
//       // } 
//       setCandidateData(candidates);
//       setCandidateCounts(candidateCount)

//         console.log(response.data);
//         handleShow();
//     } catch (error) {
//         alert("No Candidates");
//     }
// };

  const handleCheckboxChange = (type) => {
    if (type === 'all') {
        if (selectedTypes.includes('all')) {
            setSelectedTypes([]); // Deselect all
        } else {
            setSelectedTypes(REQUIREMENT_TYPES); // Select all types
        }
    } else {
        if (selectedTypes.includes(type)) {
            setSelectedTypes(selectedTypes.filter((t) => t !== type));
        } else {
            // Remove 'all' if a specific type is selected
            setSelectedTypes([...selectedTypes.filter((t) => t !== 'all'), type]);
        }
    }
};

// Update the dropdown title based on selected types
const getDropdownTitle = () => {
    if (selectedTypes.length === 0) {
        return 'Select Requirement Types';
    }
    if (selectedTypes.length === REQUIREMENT_TYPES.length) {
        return 'All';
    }
    return selectedTypes.join(', ').replace(/\b\w/g, (char) => char.toUpperCase());
};

const ViewCandidateData = async(id)=>{
  try {
      const response = await api.get(`/candidate/${id}`);
     
      setSelectedCandidate(normalizeCandidateRecord(response.data));
          setViewCandidate(true)
  } catch (error) {
      console.error('Error fetching candidates:', error);
  } 
}

  useEffect(() => {
    if (!focusedProfileId || expandedId !== focusedRequirementId) return undefined;

    const openKey = `modal:${focusedRequirementId}:${focusedProfileId}`;
    if (profileModalDeepLinkRef.current === openKey) return undefined;

    let cancelled = false;
    const timer = window.setTimeout(() => {
      if (cancelled) return;
      profileModalDeepLinkRef.current = openKey;
      ViewCandidateData(focusedProfileId);
    }, 550);

    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [focusedProfileId, focusedRequirementId, expandedId, candidateData]);

const handleStatusRemarkAdded = (updatedStatusEntry, updatedCandidate) => {
  if (updatedCandidate) {
    setSelectedCandidate(normalizeCandidateRecord(updatedCandidate));
    return;
  }
  if (updatedStatusEntry?._id) {
    setSelectedCandidate((prev) => mergeCandidateStatusRemarkUpdate(
      prev,
      updatedStatusEntry._id,
      updatedStatusEntry,
    ));
  }
};

  const handleDeleteClick = async (candidateId) => {
    const confirmDelete = window.confirm('Are you sure you want to delete this candidate?');
  
    if (confirmDelete) {
      try {
        const response = await api.delete(`/api/candidates/${candidateId}`);
  
        if (response.status === 200) {
          setCandidateData((prev) => (Array.isArray(prev) ? prev : []).filter(candidate => candidate._id !== candidateId));
          showSuccess('Candidate deleted successfully ✓');
          triggerTableRefresh(CANDIDATE_ACTIVITY_REFRESH_KEYS);
          if (show && activeReqId) {
            await refreshActiveCandidates(activeReqId);
          }
        } else {
          showError('Failed to delete candidate. Please try again.');
        }
      } catch (error) {
        console.error('Error deleting candidate:', error);
        showError(getApiErrorMessage(error, 'An error occurred while trying to delete the candidate.'));
      }
    } else {
      showInfo('Candidate deletion was canceled.');
    }
  };

  const updateCandidate = async(id)=>{
    try {
      const response = await api.get(`/candidate/${id}`)
      console.log(response.data)
      setUpdateCandidateDetails({
        ...response.data,
        lwd: normalizeLwdForInput(response.data?.lwd),
      });
      handleUpdateShow();
    } catch (error) {
      console.log(error)
    }
  }

  const handleInputChange = (field, value) => {
    setUpdateCandidateDetails(prevDetails => ({
      ...prevDetails,
      [field]: value,
    }));
  };

  const handleAssessmentChange = (index, field, value) => {
    const updatedAssessments = [...updateCandidateDetails.assessments];
    updatedAssessments[index] = {
      ...updatedAssessments[index],
      [field]: value,
    };
    setUpdateCandidateDetails(prevDetails => ({
      ...prevDetails,
      assessments: updatedAssessments,
    }));
  };

 // Function that saves changes, with conditional logic for "Upload"
const handleSaveChanges = async (status) => {
  const candidateId = updateCandidateDetails._id;

  try {
    // Prepare updated details based on whether it's a save or upload action
    const updatedDetails = {
      ...updateCandidateDetails,
      lwd: String(updateCandidateDetails.lwd || '').trim(),
      ...(status === "Uploaded" ? { savedStatus: "Uploaded", uploadedDate: new Date().toISOString() } : {})
    };

    const response = await api.put(`/candidates/${candidateId}`, updatedDetails);

    if (response.status === 200) {
      showSuccess('Candidate details updated successfully ✓');
      setUpdateshow(false);
      triggerTableRefresh(CANDIDATE_ACTIVITY_REFRESH_KEYS);
      if (show && activeReqId) {
        await refreshActiveCandidates(activeReqId);
      }
    } else {
      showError('Failed to update candidate details. Please try again.');
    }
  } catch (error) {
    console.error('Error updating candidate:', error);
    showError(getApiErrorMessage(error, 'An error occurred while updating candidate details.'));
  }
};

// Separate functions for Save and Upload buttons
const saveChanges = () => handleSaveChanges("Saved");
const uploadChanges = () => handleSaveChanges("Uploaded");


  const requirementDetails = async (id) => {
    try {
        const response = await api.get(`/getrequirements/${id}`);
        SetRequirementData(response.data); // Ensure this returns an object
        setLgShow(true);
    } catch (err) {
        console.log(err);
    }
};
  const requirementTypes = REQUIREMENT_TYPES;

  const toggleAccordion = async (id) => {
    if (expandedId === id) {
      setExpandedId(null);
      return;
    }

    try {
      const response = await api.get(`/userUploads/${id}/${userId}`);
      setCandidateData(normalizeRecruiterCandidateGroups(response.data?.recruiters || []));
      setExpandedId(id);
    } catch (error) {
      if (error.response?.status === 404) {
        setCandidateData([]);
        setExpandedId(id);
        return;
      }
      console.error('Error loading uploads:', error);
      showError(getApiErrorMessage(error, 'Unable to load candidate uploads for this requirement.'));
    }
  };
   
  return (
    <PageShell
      title="My Workbench"
      subtitle="Claim new requirements, upload candidates, and track recruitment progress."
      breadcrumbs={[
        { label: 'Dashboard', path: '/dashboard' },
        { label: 'My Workbench' },
      ]}
      backTo="/dashboard"
    >

        <div className="hr-section-toolbar hr-workbench-toolbar mb-3">
          <div className="hr-workbench-tabs" role="tablist" aria-label="My Workbench sections">
            {WORKBENCH_TABS.map((tab) => (
              <button
                key={tab.id}
                type="button"
                role="tab"
                aria-selected={activeTab === tab.id}
                className={`hr-workbench-tab${activeTab === tab.id ? ' is-active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>
          <div className="d-flex flex-wrap align-items-end gap-2">
            <FormControl
              className="hr-search"
              type="search"
              placeholder="Search by client, role, or requirement ID"
              aria-label="Search by client, role, or requirement ID"
              value={searchReq}
              onChange={(event) => setSearchReq(event.target.value)}
              style={{ minWidth: '280px' }}
            />
            <RequirementDateRangeFilter
              fromDate={uploadedFromDate}
              toDate={uploadedToDate}
              onFromChange={setUploadedFromDate}
              onToChange={setUploadedToDate}
              defaultFromDate={DEFAULT_WORKBENCH_DATE_RANGE.from}
              defaultToDate={DEFAULT_WORKBENCH_DATE_RANGE.to}
              label="Date range"
              className="hr-date-range-compact"
            />
          </div>
        </div>

        {activeTab === 'new' && (
        <div className="hr-table-card">
          <h3 className="hr-section-title">
            <img src="/Images/icon.png" alt="" />
            New Requirements
          </h3>
        <Table className="hr-table table-sm hr-requirement-list-table" responsive="sm">
          <thead>
            <tr>
              <th>Priority</th>
              <th>Reg Id</th>
              <th>Client</th>
              
              <th>Requirement Type</th>
              <th>Role</th>
              <th>Skills</th>
              <th>
                <button style={{ borderRadius: "20px" }} onClick={handleSort}>
                  <b>Start Date</b> {sortOrder === 'asc' ? '⬆️' : '⬇️'}
                </button>
              </th>
              <th>
                <button style={{ borderRadius: "20px" }} onClick={handleUploadedSort}>
                  <b>Uploaded On</b> {sortUploadedOrder === 'asc' ? '⬆️' : '⬇️'}
                </button>
              </th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {sortedRequirements
              .filter((req) => matchesUploadedDateRange(req.uploadedDate, uploadedFromDate, uploadedToDate))
              .filter((req) => matchesRequirementSearch(req, searchReq))
              .map((req, index) => (
              <tr key={index}>
                <td><PriorityBadge priority={req.priority} /></td>
                <td>{req.regId}</td>
                <td>{req.client}</td>
                <td>{normalizeRequirementType(req.requirementtype)}</td>
                <td>{req.role}</td>
                <td>{req.skill}</td>
                <td>{new Date(req.startDate).toLocaleDateString()}</td>
                <td>{new Date(req.uploadedDate).toLocaleDateString()}</td>
                <td>
                  {canClaimRequirement(req) ? (
                  <Button className="hr-btn-success" onClick={() => updateClaim(req._id)}>
                    Claim
                  </Button>
                  ) : (
                    <span className="text-muted small">—</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        </div>
        )}

        {activeTab === 'claimed' && (
        <div className="hr-table-card">
            <h3 className="hr-section-title">
                <img src="/Images/icon.png" alt="" />
                Claimed Requirements
            </h3>

            {/* Custom Dropdown with Checkbox Options */}
            <div style={{ marginBottom: '10px' }}>
                <DropdownButton
                    title={getDropdownTitle()}
                    variant="outline-secondary"
                    id="dropdown-checkbox"
                    style={{ width: '300px', fontWeight: "bolder", fontSize: "18px", textAlign: "center" }}
                >
                    {/* 'All' Option */}
                    <Dropdown.Item
                        as="div"
                        key="all"
                        onClick={(e) => e.stopPropagation()}
                        style={{ fontWeight: "bold" }}
                    >
                        <input
                            type="checkbox"
                            id="checkbox-all"
                            checked={selectedTypes.length === requirementTypes.length}
                            onChange={() => handleCheckboxChange('all')}
                        />
                         <label htmlFor="checkbox-all" style={{ marginLeft: '10px' }}>
                            All
                        </label>                        
                    </Dropdown.Item>

                    {requirementTypes.map((type) => (
                        <Dropdown.Item
                            as="div"
                            key={type}
                            onClick={(e) => e.stopPropagation()}
                            style={{ fontWeight: "bold" }}
                        >
                            <input
                                type="checkbox"
                                id={`checkbox-${type}`}
                                checked={selectedTypes.includes(type)}
                                onChange={() => handleCheckboxChange(type)}
                            />
                            <label htmlFor={`checkbox-${type}`} style={{ marginLeft: '10px' }}>
                                {type.charAt(0).toUpperCase() + type.slice(1)}
                            </label>
                        </Dropdown.Item>
                    ))}
                </DropdownButton>
            </div>

            <Table bordered hover className="hr-table table-sm hr-requirement-list-table" style={{ textAlign: 'center' }} responsive="sm">
                <thead>
                    <tr>
                        <th>Priority</th>
                        <th>Reg Id</th>
                        <th>Client</th>
                        <th>Requirement Type</th>
                        <th>Source</th>
                        <th>Role</th>
                        <th>Skills</th>
                        <th>
                            <button style={{ border: "1.5px solid black", borderRadius: "20px" }} onClick={handleSortClaimedDate}>
                                <b>Claimed On</b> {sortClaimedDateOrder === 'asc' ? '⬆️' : '⬇️'}
                            </button>
                        </th>
                        <th>Your Profiles</th>
                        <th>Rejected</th>
                        <th colSpan={2}>Action</th>
                    </tr>
                </thead>
                <tbody>
    {sortedClaimedDateRequirements
        .filter((req) => isActiveOpenRequirement(req.requirementtype))
        .filter((req) => matchesUploadedDateRange(req.uploadedDate, uploadedFromDate, uploadedToDate))
        .filter((req) => matchesRequirementSearch(req, searchReq))
        .filter((req) => {
            if (selectedTypes.length === 0) return true;
            if (selectedTypes.length === requirementTypes.length) return true;
            return matchesRequirementTypeFilter(req.requirementtype, selectedTypes);
        })
        .map((req, index) => {
            const userClaim = req.currentClaimedBy || (req.claimedBy || []).find((claim) => claim.userId === userId);
            const count = candidateCounts[req._id] || req.workflow?.candidateCount || 0;
            const rejectedCount = rejectedCounts[req._id] || 0;
            const uploadAllowed = canUploadToRequirement(req);
            const showUnclaim = canUnclaimRequirement(req);
            const countColor = count > 5 ? 'MediumSeaGreen' : count >= 3 ? 'rgb(255, 200, 0)' : 'indianred';
            const buttonColor = count > 5 ? 'MediumSeaGreen' : count >= 3 ? 'rgb(255, 200, 0)' : 'indianred';
            const textColor = buttonColor === '' ? 'black' : 'white';

            return (
                <React.Fragment key={index}>
                    <tr>
                        <td><PriorityBadge priority={req.priority} /></td>
                        <td><Link style={{ textDecoration: "none" }} onClick={() => requirementDetails(req._id)}><b>{req.regId}</b></Link></td>
                        <td>{req.client}</td>
                        <td>{normalizeRequirementType(req.requirementtype)}</td>
                        <td>
                          <span className={`badge ${getRequirementSourceBadgeClass(getRequirementSourceFromRow(req), req)}`}>
                            {getRequirementSourceFromRow(req)}
                          </span>
                        </td>
                        <td>{req.role}</td>
                        <td>{req.skill}</td>
                        <td>{userClaim ? new Date(userClaim.claimedDate).toLocaleDateString() : 'N/A'}</td>
                        <td>
                            <Link 
                                onMouseMove={(e) => {
                                    e.target.style.backgroundColor = "lightgray";
                                    e.target.style.color = "black";
                                }} 
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = countColor;
                                    e.target.style.color = "white";
                                }} 
                                onClick={() => viewCandidates(req._id)} 
                                style={{ 
                                    textDecoration: 'none',
                                    width: '45px',
                                    height: '45px',
                                    margin: '10px',
                                    fontWeight: 'bold',
                                    backgroundColor: countColor,
                                    borderRadius: '90px',
                                    border: '1.5px solid black',
                                    padding: '8px',
                                    color: 'white' 
                                }}
                            >
                                {count}
                            </Link>
                        </td>
                        <td>
                            <button
                                type="button"
                                className={`btn btn-link p-0 hr-table-link-btn hr-table-count-btn${rejectedCount === 0 ? ' is-zero' : ' is-alert'}`}
                                onClick={() => openRejectedModal(req._id, req.regId)}
                                style={{ textDecoration: 'none' }}
                            >
                                <strong
                                    style={{
                                        width: '45px',
                                        height: '45px',
                                        margin: '10px',
                                        fontWeight: 'bold',
                                        backgroundColor: rejectedCount > 0 ? 'indianred' : 'lightgray',
                                        borderRadius: '90px',
                                        border: '1.5px solid black',
                                        padding: '8px',
                                        color: rejectedCount > 0 ? 'white' : 'black',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    {rejectedCount}
                                </strong>
                            </button>
                        </td>
                        <td>
    <Button
        onClick={() => {
            if (!isRequirementWorkBlocked(req.requirementtype) && uploadAllowed) {
                openFormModal('upload-candidate', { reqId: req._id, workflow: req.workflow });
            } else if (!uploadAllowed) {
                showWarning(getUploadDisabledMessage(req));
            }
        }}
        onMouseMove={(e) => { 
            if (!isRequirementWorkBlocked(req.requirementtype) && uploadAllowed) {
                e.target.style.backgroundColor = "gray"; 
            }
        }} 
        onMouseLeave={(e) => { 
            if (!isRequirementWorkBlocked(req.requirementtype) && uploadAllowed) {
                e.target.style.backgroundColor = buttonColor; 
            }
        }} 
        style={{ 
            border: '1px solid gray',
            backgroundColor: isRequirementWorkBlocked(req.requirementtype) || !uploadAllowed ? 'lightgray' : buttonColor,
            borderRadius: '20px',
            color: isRequirementWorkBlocked(req.requirementtype) || !uploadAllowed ? 'darkgray' : textColor,
            fontWeight: "bold",
            cursor: isRequirementWorkBlocked(req.requirementtype) || !uploadAllowed ? 'not-allowed' : 'pointer'
        }}
        disabled={isRequirementWorkBlocked(req.requirementtype) || !uploadAllowed}
        title={!uploadAllowed ? getUploadDisabledMessage(req) : ''}
    >
        {uploadAllowed ? 'Take Action' : 'Upload Disabled'}
    </Button>
    {showUnclaim && (
      <Button
        variant="outline-warning"
        className="ms-2"
        onClick={() => handleUnclaim(req._id)}
      >
        Unclaim
      </Button>
    )}
</td>

                        <td>
                            <Link 
                                onClick={() => toggleAccordion(req._id)} 
                                onMouseMove={(e) => {
                                    e.target.style.backgroundColor = "gray";
                                    e.target.style.color = "white";
                                }} 
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = "";
                                    e.target.style.color = "black";
                                }}
                            >
                                <Image
                                    style={{
                                        padding: "10px",
                                        borderRadius: "10px",
                                    }}
                                    src='./Images/expand.svg'
                                    alt="Expand Icon"
                                />
                            </Link>
                        </td>
                    </tr>

                    {expandedId === req._id && (
                        <tr>
                            <td colSpan="12">
                                <Accordion activeKey="0">
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Body>
                                            <Table bordered hover responsive className="table-sm" style={{ textAlign: "center" }}>
                                                <thead>
                                                    <tr>
                                                        <th>Employee Name</th>
                                                        <th>Source Profile Name</th>
                                                        <th>Role</th>
                                                        <th>ECTC</th>
                                                        <th>LWD</th>
                                                        <th>Status</th>
                                                        <th colSpan={2}>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {(Array.isArray(candidateData) ? candidateData : []).map((item, i) => (
                                                        <React.Fragment key={i}>
                                                            {(item.candidates || []).length > 0 ? (
                                                                (item.candidates || []).filter(candidate => {
                                                                    const recentStatus = getRecentCandidateStatus(candidate);

                                                                    const matchesStatus = selectedCandidateStatus ? recentStatus === selectedCandidateStatus : true;
                                                                    const matchesName = candidateName 
                                                                        ? `${candidate.firstName} ${candidate.lastName}`.toLowerCase().includes(candidateName.toLowerCase())
                                                                        : true;

                                                                    return matchesStatus && matchesName;
                                                                }).map((candidate, index) => {
                                                                    const recentStatus = getRecentCandidateStatus(candidate);

                                                                    return (
                                                                        <tr
                                                                            key={candidate._id || index}
                                                                            id={candidate._id ? `profile-row-${candidate._id}` : undefined}
                                                                        >
                                                                            {index === 0 && (
                                                                                <td rowSpan={(item.candidates || []).length}>{item.recruiter?.EmployeeName}</td>
                                                                            )}
                                                                            <td>{candidate.firstName} {candidate.lastName}</td>
                                                                            <td>{candidate.role}</td>
                                                                            <td>{candidate.ectc}</td>
                                                                            <td>{formatLwdDisplay(candidate.lwd)}</td>
                                                                            <td>
                                                                                <StatusBadge status={recentStatus} useStoredLabel />
                                                                            </td>
                                                                            <td>
                                                                                <ActionIcon
                                                                                    variant="view"
                                                                                    src="/Images/view.svg"
                                                                                    alt="View candidate"
                                                                                    onClick={() => ViewCandidateData(candidate._id)}
                                                                                />
                                                                            </td>
                                                                            <td>
                        {candidate.savedStatus === 'Saved' && ( // Only show Upload button if savedStatus is 'Saved'
                                <Button onClick={() => updateCandidate(candidate._id)} style={{fontWeight:"bold",backgroundColor:"green",border:"0px",padding:"5px",borderRadius:"20px"}} onMouseMove={(e)=> { e.target.style.backgroundColor = "gray";e.target.style.padding = "10px"; }} onMouseLeave={(e)=> { e.target.style.backgroundColor = "green";e.target.style.padding = "5px"; }}>Upload</Button>
                            )}
                        </td>
                                                                        </tr>
                                                                    );
                                                                })
                                                            ) : (
                                                                <tr key={i}>
                                                                    <td>{item.recruiter?.EmpCode}</td>
                                                                    <td>{item.recruiter?.EmployeeName}</td>
                                                                    <td colSpan={6}>No Source Profiles</td>
                                                                </tr>
                                                            )}
                                                        </React.Fragment>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </td>
                        </tr>
                    )}
                </React.Fragment>
            );
        })}
</tbody>

            </Table>
        </div>
        )}

        {activeTab === 'priority' && (
        <div className="hr-table-card">
          <h3 className="hr-section-title">
            <img src="/Images/icon.png" alt="" />
            Priority Requirement List
          </h3>
          <Table bordered hover className="hr-table table-sm hr-requirement-list-table" style={{ textAlign: 'center' }} responsive="sm">
            <thead>
              <tr>
                <th>Priority</th>
                <th>Reg Id</th>
                <th>Client</th>
                <th>Requirement Type</th>
                <th>Role</th>
                <th>Skills</th>
                <th>Status</th>
                <th>Your Profiles</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredPriorityRequirements.length === 0 ? (
                <tr>
                  <td colSpan={9}>No priority requirements available.</td>
                </tr>
              ) : (
                filteredPriorityRequirements.map((req) => {
                  const isClaimable = canClaimRequirement(req);
                  const count = candidateCounts[req._id] || req.workflow?.candidateCount || 0;

                  return (
                    <tr key={req._id}>
                      <td><PriorityBadge priority={req.priority} /></td>
                      <td>
                        {!isClaimable ? (
                          <Link style={{ textDecoration: 'none' }} onClick={() => requirementDetails(req._id)}>
                            <b>{req.regId}</b>
                          </Link>
                        ) : (
                          <b>{req.regId}</b>
                        )}
                      </td>
                      <td>{req.client}</td>
                      <td>{normalizeRequirementType(req.requirementtype)}</td>
                      <td>{req.role}</td>
                      <td>{req.skill}</td>
                      <td>{isClaimable ? 'Available' : 'Claimed'}</td>
                      <td>{isClaimable ? '—' : count}</td>
                      <td>
                        {isClaimable ? (
                          <Button className="hr-btn-success" onClick={() => updateClaim(req._id)}>
                            Claim
                          </Button>
                        ) : (
                          <Button
                            onClick={() => {
                              if (!isRequirementWorkBlocked(req.requirementtype) && canUploadToRequirement(req)) {
                                openFormModal('upload-candidate', { reqId: req._id, workflow: req.workflow });
                              } else if (!canUploadToRequirement(req)) {
                                showWarning(getUploadDisabledMessage(req));
                              }
                            }}
                            disabled={isRequirementWorkBlocked(req.requirementtype) || !canUploadToRequirement(req)}
                          >
                            Upload Profiles
                          </Button>
                        )}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </Table>
        </div>
        )}

        <Modal
    className="hr-modal"
    show={show}
    onHide={() => {
        setSelectedCandidate(null);
        onHide();
    }}
    fullscreen
    aria-labelledby="example-custom-modal-styling-title"
>
    <Modal.Header closeButton className="hr-modal-header">
        <Modal.Title>
            <h5>
                <img style={{ width: "30px", margin: "10px" }} src='/Images/icon.png' alt="icon" />
                <b style={{ fontFamily: "monospace" }}>Source Profile Details</b>
            </h5>
        </Modal.Title>
    </Modal.Header>

    <Modal.Body>
    {/* Name Search Input Field */}
   <center>
   <input
        type="text"
        placeholder="Search by name..."
        value={nameSearchTerm}
        onChange={(e) => setNameSearchTerm(e.target.value)}
        style={{ marginBottom: "10px", padding: "10px", width: "300px", border: "2px solid black", borderRadius: "20px",margin:"5px" }}
    />
    

    {/* Status Selection Dropdown */}
    <select
        value={statusSearchTerm}
        onChange={(e) => setStatusSearchTerm(e.target.value)}
        style={{ marginBottom: "20px", padding: "10px", width: "300px", border: "2px solid black", borderRadius: "20px",margin:"5px" }}
    >
        <option value="">All</option> {/* Default option */}
        {statusOptions.map((status, index) => (
            <option key={index} value={status.toLowerCase()}>{status}</option>
        ))}
    </select>

    {/* Saved Status Selection Dropdown */}
    <select
        value={savedStatusSearchTerm}
        onChange={(e) => setSavedStatusSearchTerm(e.target.value)}
        style={{ marginBottom: "20px", padding: "10px", width: "300px", border: "2px solid black", borderRadius: "20px",margin:"5px" }}
    >        <option value="">Select Type</option>
        <option value="">All</option>
        <option value="saved">Saved</option>
        <option value="uploaded">Uploaded</option>
    </select></center> <hr></hr>

    <Table hover bordered responsive style={{ textAlign: "center" }}>
        <thead>
            <tr>
                <th>Name</th>
                <th>Role</th>
                <th>Total YOE</th>
                <th>LWD</th>
                <th>ECTC</th>
                <th>Status</th>
                <th>Uploaded On</th>
                <th colSpan={4}>Actions</th>
              
            </tr>
        </thead>
        <tbody>
            {filteredCandidates.map((item, index) => {
                const recentStatus = getRecentCandidateStatus(item);
                const isDeleteEnabled = recentStatus === "No Action Taken";

                return (
                    <tr key={index}>
                        <td>{item.firstName} {item.lastName}</td>
                        <td>{item.role}</td>
                        <td>{item.totalYoe}</td>
                        <td>{formatLwdDisplay(item.lwd)}</td>
                        <td>{item.ectc}</td>
                        <td>
                            <StatusBadge status={recentStatus} useStoredLabel />
                        </td>
                        <td>{new Date(item.uploadedOn).toLocaleDateString()}</td>
                        <td>
                            <ActionIcon
                                variant="view"
                                src="/Images/view.svg"
                                alt="View candidate"
                                onClick={() => ViewCandidateData(item._id)}
                            />
                        </td>
                            <td>
                            <Link onMouseMove={(e)=> { e.target.style.backgroundColor="gray"; }} onMouseLeave={(e)=> { e.target.style.backgroundColor= isDeleteEnabled ? "IndianRed" : "lightgray"; }} onClick={isDeleteEnabled ? () => handleDeleteClick(item._id) : undefined}>
                                <Image
                                    style={{
                                        backgroundColor: isDeleteEnabled ? "IndianRed" : "lightgray", // Change color if disabled
                                        
                                        padding: "10px",
                                        borderRadius: "10px",
                                        cursor: isDeleteEnabled ? "pointer" : "not-allowed" // Change cursor style if disabled
                                    }}
                                    src='/Images/trash.svg'
                                    alt="Delete"
                                />
                            </Link>
                            </td>
                            <td>
                            <Link onMouseMove={(e)=> { e.target.style.backgroundColor="gray"; }} onMouseLeave={(e)=> { e.target.style.backgroundColor= isDeleteEnabled ? "lightgreen" : "lightgray"; }} onClick={isDeleteEnabled ? () => updateCandidate(item._id): undefined}>
                                <Image style={{ backgroundColor: isDeleteEnabled ? "lightgreen" : "lightgray", padding: "10px",  borderRadius: "10px",cursor: isDeleteEnabled ? "pointer" : "not-allowed" }} src='/Images/edit.svg' />
                            </Link>
                           
                        </td>
                        <td>
                        {item.savedStatus === 'Saved' && ( // Only show Upload button if savedStatus is 'Saved'
                                <Button onClick={() => updateCandidate(item._id)} style={{fontWeight:"bold",backgroundColor:"green",border:"0px",padding:"5px",borderRadius:"20px"}} onMouseMove={(e)=> { e.target.style.backgroundColor = "gray";e.target.style.padding = "10px"; }} onMouseLeave={(e)=> { e.target.style.backgroundColor = "green";e.target.style.padding = "5px"; }}>Upload</Button>
                            )}
                        </td>
                    </tr>
                );
            })}
        </tbody>
    </Table>
</Modal.Body>

</Modal>

    <Modal
      className="hr-modal"
      show={updateshow}
      size="lg"
      onHide={handleUpdateClose}
      dialogClassName="modal-90w"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-custom-modal-styling-title">
          <h5>
            <img style={{ width: "30px", margin: "10px" }} src='/Images/icon.png' alt="icon"></img>
            <b style={{ fontFamily: "monospace" }}>Update Source Profile Information</b>
          </h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <form style={{backgroundColor:"lightsteelblue",borderRadius:"20px"}}>
            <div className="container">
                <div className="row">
                    <div className="col-md-6 form-group">
                        <label><strong>Candidate Image:</strong></label>
                        <div>
                            <img
                                src={`${API_BASE_URL}/${updateCandidateDetails.candidateImage}`}
                                style={{ width: "100px", borderRadius: "100px" }}
                                alt=""
                            />
                        </div>
                    </div>
                    
                </div>
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>First Name:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.firstName}
                            onChange={(e) => handleInputChange('firstName', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>Last Name:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.lastName}
                            onChange={(e) => handleInputChange('lastName', e.target.value)}
                        />
                    </div>
                    
                </div>
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>Email:</strong></label>
                        <input
                            type="email"
                            className="form-control"
                            value={updateCandidateDetails.email}
                            onChange={(e) => handleInputChange('email', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>Mobile Number:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.mobileNumber}
                            onChange={(e) => handleInputChange('mobileNumber', e.target.value)}
                        />
                    </div>
                   
                </div>
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>Date of Birth:</strong></label>
                        <input
                            type="date"
                            className="form-control"
                            value={toDateInputValue(updateCandidateDetails.dob)}
                            onChange={(e) => handleInputChange('dob', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>CTC:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.ctc}
                            onChange={(e) => handleInputChange('ctc', e.target.value)}
                        />
                    </div>
                   
                </div>
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>ECTC:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.ectc}
                            onChange={(e) => handleInputChange('ectc', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>Total YOE:</strong></label>
                        <input
                            type="number"
                            className="form-control"
                            value={updateCandidateDetails.totalYoe}
                            onChange={(e) => handleInputChange('totalYoe', e.target.value)}
                        />
                    </div>
                    
                </div>
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>Relevant YOE:</strong></label>
                        <input
                            type="number"
                            className="form-control"
                            value={updateCandidateDetails.relevantYoe}
                            onChange={(e) => handleInputChange('relevantYoe', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>LWD:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.lwd ?? ''}
                            onChange={(e) => handleInputChange('lwd', e.target.value)}
                            placeholder="LWD"
                        />
                    </div>
                    
                </div>
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>Current Location:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.currentLocation}
                            onChange={(e) => handleInputChange('currentLocation', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>Preferred Location:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.prefLocation}
                            onChange={(e) => handleInputChange('prefLocation', e.target.value)}
                        />
                    </div>
                    
                </div>
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>Resignation Served:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.resignationServed}
                            onChange={(e) => handleInputChange('resignationServed', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>Current Organization:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.currentOrg}
                            onChange={(e) => handleInputChange('currentOrg', e.target.value)}
                        />
                    </div>
                    
                </div>
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>Candidate Skills:</strong></label>
                        <textarea
                            className="form-control"
                            value={updateCandidateDetails.candidateSkills}
                            onChange={(e) => handleInputChange('candidateSkills', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>Role:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.role}
                            onChange={(e) => handleInputChange('role', e.target.value)}
                        />
                    </div>
                   
                </div>
                {/* <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>Internal Screening:</strong></label>
                        <select
                            className="form-control"
                            value={updateCandidateDetails.internalScreening}
                            onChange={(e) => handleInputChange('internalScreening', e.target.value)}
                        >
                            <option value="Selected">Selected</option>
                            <option value="Rejected">Rejected</option>
                        </select>
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>Shared With Client:</strong></label>
                        <select
                            className="form-control"
                            value={updateCandidateDetails.sharedWithClient}
                            onChange={(e) => handleInputChange('sharedWithClient', e.target.value)}
                        >
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                   
                </div> */}
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>Recruiter Feedback:</strong></label>
                        <textarea
                            className="form-control"
                            value={updateCandidateDetails.feedback}
                            onChange={(e) => handleInputChange('feedback', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>About Candidate:</strong></label>
                        <textarea
                            className="form-control"
                            value={updateCandidateDetails.details}
                            onChange={(e) => handleInputChange('details', e.target.value)}
                        />
                    </div>
                    
                </div>
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>Interview Date:</strong></label>
                        <input
                            type="date"
                            className="form-control"
                            value={new Date(updateCandidateDetails.interviewDate).toLocaleDateString('en-CA')}
                            onChange={(e) => handleInputChange('interviewDate', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>Educational Qualification:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.educationalQualification}
                            onChange={(e) => handleInputChange('educationalQualification', e.target.value)}
                        />
                    </div>
                    
                </div>
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>Offer In Hand:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.offerInHand}
                            onChange={(e) => handleInputChange('offerInHand', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>Last Interview Date:</strong></label>
                        <input
                            type="date"
                            className="form-control"
                            value={new Date(updateCandidateDetails.interviewDate).toLocaleDateString('en-CA')}
                            onChange={(e) => handleInputChange('lastInterviewDate', e.target.value)}
                        />
                    </div>
                </div> <hr></hr>
                <div className="row">
            <div className="col-md-12 form-group">
                <h3>
                    <img style={{width: "30px", margin: "10px"}} src='/Images/icon.png' alt="icon" />
                    <b style={{fontFamily: "monospace"}}>Assessment Details</b>
                </h3>
                {updateCandidateDetails.assessments.map((assessment, index) => (
                    <div key={index} className="form-group">
                        <label><strong>Assessment {index + 1}:</strong></label>
                        <input
                            readOnly
                            type="text"
                            className="form-control"
                            value={assessment.assessment}
                        />
                        <label><strong>Expected Rating:</strong></label>
                        <input
                            readOnly
                            type="text"
                            className="form-control"
                            value={assessment.yoe}
                        />
                        <label><strong>Candidate Rating:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={assessment.score}
                            onChange={(e) => handleAssessmentChange(index, 'score', e.target.value)}
                        />
                        <hr />
                    </div>
                ))}
            </div>
        </div>
            </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
      {updateCandidateDetails.savedStatus === "Saved" && (
                    <Button style={{borderRadius:"20px",backgroundColor:"mediumseagreen",color:"white",border:"1.5px solid black",fontWeight:"bold"}}
                        type="button"
                        className="btn btn-secondary ml-2"
                        onMouseMove={(e)=> { e.target.style.backgroundColor = "lightgray";e.target.style.color = "black";e.target.style.padding = "10px"; }}
                        onMouseLeave={(e)=> { e.target.style.backgroundColor = "mediumseagreen";e.target.style.color = "white";e.target.style.padding = "7px"; }}
                        onClick={uploadChanges}
                        // onClick={handleUploadStatus}
                    >
                        Upload
                    </Button>
                )}
        <Button                         onMouseMove={(e)=> { e.target.style.backgroundColor = "green";e.target.style.color = "white";e.target.style.padding = "10px"; }}
                        onMouseLeave={(e)=> { e.target.style.backgroundColor = "lightgray";e.target.style.color = "green";e.target.style.padding = "7px"; }}
 style={{borderRadius:"20px",backgroundColor:"lightgray",color:"green",border:"1.5px solid black",fontWeight:"bold"}} onClick={saveChanges}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>

    <Modal className="hr-modal" size="lg" show={lgShow} onHide={() => setLgShow(false)} aria-labelledby="example-modal-sizes-title-lg">
    <Modal.Header closeButton className="hr-modal-header">
        <Modal.Title id="example-modal-sizes-title-lg">
            <h5> <img style={{ width: "30px", margin: "10px" }} src='/Images/icon.png' alt="icon"></img><b style={{fontFamily:"monospace"}} >RegId:</b>{requirementData.regId}</h5> {/* Displaying single requirement detail */}
        </Modal.Title>
    </Modal.Header>
    <Modal.Body>
    <div className="table-responsive">
    <Table responsive  bordered hover className="table-sm">
                    <tbody>
                        <tr>
                            <td><b>Client:</b></td>
                            <td>{requirementData.client}</td>
                        </tr>
                        <tr>
                            <td><b>Requirement Type:</b></td>
                            <td>{normalizeRequirementType(requirementData.requirementtype)}</td>
                        </tr>
                        <tr>
                            <td><b>Priority:</b></td>
                            <td><PriorityBadge priority={requirementData.priority} /></td>
                        </tr>
                        <tr>
                            <td><b>Type Of Contract:</b></td>
                            <td>{requirementData.typeOfContract}</td>
                        </tr>
                        <tr>
                            <td><b>Start Date:</b></td>
                            <td>{new Date(requirementData.startDate).toLocaleDateString()}</td>
                        </tr>
                        <tr>
                            <td><b>Duration:</b></td>
                            <td>{requirementData.duration}</td>
                        </tr>
                        <tr>
                            <td><b>Number of Positions:</b></td>
                            <td>{requirementData.numberOfPositions ?? 1}</td>
                        </tr>
                        <tr>
                            <td><b>Location:</b></td>
                            <td>{requirementData.location}</td>
                        </tr>
                        <tr>
                            <td><b>Source CTC:</b></td>
                            <td>{requirementData.sourceCtc}</td>
                        </tr>
                        <tr>
                            <td><b>Qualification:</b></td>
                            <td>{requirementData.qualification}</td>
                        </tr>
                        <tr>
                            <td><b>YOE:</b></td>
                            <td>{requirementData.yearsExperience}</td>
                        </tr>
                        <tr>
                            <td><b>Relevant YOE:</b></td>
                            <td>{requirementData.relevantExperience}</td>
                        </tr>
                        <tr>
                            <td><b>Skill:</b></td>
                            <td>{requirementData.skill}</td>
                        </tr>
                        <tr>
                            <td><b>Uploaded Date:</b></td>
                            <td>{ new Date(requirementData.uploadedDate).toLocaleDateString()}</td>
                        </tr>
                        <tr>
                            <td><b>Job Description:</b></td>
                            <td><RequirementJdActions requirement={requirementData} /></td>
                        </tr>

                        {/* Assessment Section */}
                          <tr>
                            <td colSpan="2"><center><label> <h5> <img style={{ width: "30px", margin: "10px" }} src='/Images/icon.png' alt="icon"></img><b style={{fontFamily:"monospace"}} >Assessment</b></h5></label></center></td>
                        </tr>
                        {requirementData.assessments && requirementData.assessments.length > 0 ? (
                             requirementData.assessments.map((assessment, index) => (
                             <React.Fragment key={index}>
                                   <tr>
                                       <td><b>Assessment:</b></td>
                                       <td>{assessment.assessment}</td>
                                   </tr>
                                   <tr>
                                       <td><b>Expected Rating:</b></td>
                                       <td>{assessment.yoe}</td>
                                   </tr> <hr></hr>
                               </React.Fragment>
                           ))) : (
                                    <tr>
                                         <td colSpan="2">No assessments available</td>
                                    </tr>
                            )}

                    </tbody>
                </Table>
                </div>
    </Modal.Body>
               </Modal>
               <AppModal
        size="xl"
        show={viewCandidate}
        onHide={() => setViewCandidate(false)}
        title="Source Profile Details"
        subtitle={
          selectedCandidate && selectedCandidate.firstName
            ? `${selectedCandidate.firstName} ${selectedCandidate.lastName || ''}`.trim()
            : ''
        }
        footer={(
          <>
            <Button variant="secondary" onClick={() => setViewCandidate(false)}>
              Close
            </Button>
            <Button
              variant="primary"
              className="hr-btn-primary"
              disabled={!canEditFullSourceProfileDetails(selectedCandidate)}
              title={
                !canEditFullSourceProfileDetails(selectedCandidate)
                  ? 'Profile fields can be edited only when status is No Action Taken. Resume and Ornnova profile can still be updated below.'
                  : ''
              }
              onClick={() => {
                if (selectedCandidate?._id) {
                  updateCandidate(selectedCandidate._id);
                  setViewCandidate(false);
                }
              }}
            >
              Edit
            </Button>
          </>
        )}
      >
        {viewCandidate && selectedCandidate && (
        <div>
          <Table responsive bordered hover className="hr-table table-sm">
            <tbody>
              <tr>
                <td>
                  <Image
                    src={buildApiAssetUrl(selectedCandidate.candidateImage)}
                    style={{ width: "100px", borderRadius: "100px" }}
                    alt="Candidate Image"
                  />
                </td>
                <td>
                  <center>
                    <strong>Updated Status</strong> <hr></hr>
                    <StatusHistorySection
                      candidate={selectedCandidate}
                      candidateId={selectedCandidate._id}
                      onRemarkAdded={handleStatusRemarkAdded}
                      emptyMessage="No Action Taken"
                    />
                  </center>
                </td>
              </tr>
              {/* Rest of your candidate details as in your provided code */}
              <tr>
                <td><b>Source Profile Name</b></td>
                <td>{selectedCandidate.firstName} {selectedCandidate.lastName}</td>
              </tr>
<tr>
    <td><b>Email:</b></td>
    <td>{selectedCandidate.email}</td>
</tr>
<tr>
    <td><b>Date of Birth:</b></td>
    <td>{formatDisplayDate(selectedCandidate.dob)}</td>
</tr>
<tr>
    <td><b>Mobile Number:</b></td>
    <td>{selectedCandidate.mobileNumber}</td>
</tr>
{/* Uncomment the following if client information is needed
<tr>
    <td><b>Client:</b></td>
    <td>{candidateDetails.client}</td>
</tr>
*/}
<tr>
    <td><b>Skills:</b></td>
    <td>{selectedCandidate.candidateSkills}</td>
</tr>
<tr>
    <td><b>CTC:</b></td>
    <td>{selectedCandidate.ctc}</td>
</tr>
<tr>
    <td><b>Expected CTC:</b></td>
    <td>{selectedCandidate.ectc}</td>
</tr>
<tr>
    <td><b>Educational Qualification:</b></td>
    <td>{selectedCandidate.educationalQualification}</td>
</tr>
<tr>
    <td><b>Total YOE:</b></td>
    <td>{selectedCandidate.totalYoe}</td>
</tr>
<tr>
    <td><b>Relevant YOE:</b></td>
    <td>{selectedCandidate.relevantYoe}</td>
</tr>
<tr>
    <td><b>Current Location:</b></td>
    <td>{selectedCandidate.currentLocation}</td>
</tr>
<tr>
    <td><b>Preferred Location:</b></td>
    <td>{selectedCandidate.prefLocation}</td>
</tr>
<tr>
    <td><b>Current Organization:</b></td>
    <td>{selectedCandidate.currentOrg}</td>
</tr>
<tr>
    <td><b>Role:</b></td>
    <td>{selectedCandidate.role}</td>
</tr>
<tr>
    <td><b>Resignation Served:</b></td>
    <td>{selectedCandidate.resignationServed}</td>
</tr>
<tr>
    <td><b>Last Working Date:</b></td>
    <td>{formatLwdDisplay(selectedCandidate.lwd)}</td>
</tr>
{/* Uncomment the following if status information is needed
<tr>
    <td><b>Status:</b></td>
    <td>{candidateDetails.Status}</td>
</tr>
*/}
<tr>
    <td><b>Offer In Hand:</b></td>
    <td>{selectedCandidate.offerInHand}</td>
</tr>
<tr>
    <td><b>Interview Date:</b></td>
    <td>{formatInterviewDate(selectedCandidate.interviewDate)}</td>
</tr>
<tr>
    <td><b>About Source Profile:</b></td>
    <td>{selectedCandidate.details}</td>
</tr>
<tr>
    <td><b>Recruiter Feedback:</b></td>
    <td>{selectedCandidate.feedback}</td>
</tr>
<tr>
    <td><b>Remark:</b></td>
    <td>{selectedCandidate.remark}</td>
</tr>
{/* Uncomment the following if shared with client information is needed
<tr>
    <td><b>Shared With Client:</b></td>
    <td>{candidateDetails.sharedWithClient}</td>
</tr>
*/}
<SourceProfileDocumentFields
  candidateId={selectedCandidate._id}
  updatedResume={selectedCandidate.updatedResume}
  ornnovaProfile={selectedCandidate.ornnovaProfile}
  canUpload
  onDocumentsUpdated={(updated) => {
    if (!updated) return;
    setSelectedCandidate((prev) => (prev ? { ...prev, ...updated } : prev));
  }}
/>
<tr>
    <td colSpan="2">
        <center>
            <h5>
                <img style={{ width: "30px", margin: "10px" }} src='/Images/icon.png' alt="icon" />
                <b style={{ fontFamily: "monospace" }}>Assessment</b>
            </h5>
        </center>
    </td>
</tr>
{
    selectedCandidate.assessments && Array.isArray(selectedCandidate.assessments) && selectedCandidate.assessments.length > 0 ? (
        selectedCandidate.assessments.map((item, index) => (
            <React.Fragment key={index}>
                <tr>
                    <td><b>Assessment:</b></td>
                    <td>{item.assessment}</td>
                </tr>
                <tr>
                    <td><b>Expected Rating:</b></td>
                    <td>{item.yoe}</td>
                </tr>
                <tr>
                    <td><b>Candidate Rating:</b></td>
                    <td>{item.score}</td>
                </tr>
                <tr>
                    <td colSpan={2}><hr /></td>
                </tr>
            </React.Fragment>
        ))
    ) : (
        <tr>
            <td colSpan={2}>No assessments available.</td>
        </tr>
    )
}            </tbody>
          </Table>
        </div>
      )}

      </AppModal>

      <RequirementRejectedModal
        show={showRejectedModal}
        onHide={closeRejectedModal}
        subtitle={rejectedModalMeta.regId ? `Req ID: ${rejectedModalMeta.regId}` : ''}
        rows={rejectedRows}
        loading={rejectedLoading}
      />

    </PageShell>
  );
}

export default Home;
